import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import "@/components/data-protection/data-protection.css"

@customElement('sbk-data-protection')
export class SbkDataProtection extends LitElement {
    protected createRenderRoot() {
        return this;
    }
}
